/* Coffee page helpers: roast and taste filters, sorting, and a three-question coffee finder.
   Everything reads the data-* attributes film-products.liquid writes on each coffee card, so the cards stay the one source. */
(function () {
  'use strict';

  var ROAST_GROUP = { 1: 'light', 2: 'medium', 3: 'medium-dark', 4: 'dark', 5: 'dark' };
  var BREW_WORDS = { drip: 'your drip machine', espresso: 'espresso', press: 'your French press', pourover: 'pour over' };
  var BREW_GRIND = { drip: 'drip-auto-brew', espresso: 'espresso', press: 'french-press', pourover: 'pour-over', whole: 'whole-bean' };

  var QUESTIONS = [
    {
      id: 'cup',
      text: 'How do you like your cup?',
      answers: [
        { label: 'Light and bright', value: { roast: 1 } },
        { label: 'Smooth and easy', value: { roast: 2 } },
        { label: 'Bold and dark', value: { roast: 4.5 } },
        { label: 'Decaf, same flavour', value: { decaf: true } }
      ]
    },
    {
      id: 'taste',
      text: 'Which flavours do you reach for?',
      answers: [
        { label: 'Chocolate and fudge', value: { taste: 'chocolate' } },
        { label: 'Nuts and toffee', value: { taste: 'nutty' } },
        { label: 'Bright and fruity', value: { taste: 'fruity' } },
        { label: 'Caramel and sweet', value: { taste: 'sweet' } }
      ]
    },
    {
      id: 'brew',
      text: 'How do you brew it?',
      answers: [
        { label: 'Drip machine', value: { brew: 'drip' } },
        { label: 'Espresso', value: { brew: 'espresso' } },
        { label: 'French press', value: { brew: 'press' } },
        { label: 'Pour over', value: { brew: 'pourover' } },
        { label: 'Whole bean, I grind it', value: { brew: 'whole' } }
      ]
    }
  ];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function cardData(card) {
    var d = card.dataset;
    var grinds = {};
    (d.grinds || '').split(';').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && kv[0]) grinds[kv[0]] = kv[1];
    });
    return {
      card: card,
      index: parseInt(d.index, 10) || 0,
      roast: parseInt(d.roast, 10) || 2,
      decaf: d.decaf === 'true',
      tastes: (d.tastes || '').split(/\s+/).filter(Boolean),
      brews: (d.brews || '').split(/\s+/).filter(Boolean),
      price: parseInt(d.price, 10) || 0,
      grinds: grinds,
      url: d.url || '#',
      name: d.name || '',
      roastLabel: d.roastLabel || '',
      origin: d.origin || '',
      notes: d.notes || '',
      line: d.line || '',
      photo: d.photo || '',
      money: d.money || ''
    };
  }

  function init(section) {
    var grid = section.querySelector('[data-fs-grid]');
    if (!grid) return;
    var coffees = Array.prototype.map.call(grid.querySelectorAll('[data-fs-card]'), cardData);
    if (!coffees.length) return;
    setupTools(section, grid, coffees);
    setupFinder(section, coffees);
  }

  /* ---------- Filters and sorting ---------- */
  function setupTools(section, grid, coffees) {
    var tools = section.querySelector('[data-fs-tools]');
    if (!tools) return;
    var chips = Array.prototype.slice.call(tools.querySelectorAll('[data-filter]'));
    var sort = tools.querySelector('[data-fs-sort]');
    var count = tools.querySelector('[data-fs-count]');
    var clears = section.querySelectorAll('[data-fs-clear]');
    var empty = section.querySelector('[data-fs-empty]');
    var clearInBar = tools.querySelector('[data-fs-clear-bar]');
    var toggle = tools.querySelector('[data-fs-toggle]');
    var badge = tools.querySelector('[data-fs-badge]');
    var done = tools.querySelector('[data-fs-done]');

    // Phones: the filters live in a panel that opens from the Filter button
    function openPanel(open) {
      tools.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (toggle) toggle.addEventListener('click', function () { openPanel(!tools.classList.contains('is-open')); });
    if (done) done.addEventListener('click', function () {
      openPanel(false);
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // A chip that matches no coffee is left out, so every chip on the page does something
    chips.forEach(function (chip) {
      var f = chip.dataset.filter, v = chip.dataset.value;
      var any = coffees.some(function (c) { return matches(c, f, [v]); });
      if (!any) chip.hidden = true;
    });

    function active(filter) {
      return chips.filter(function (c) { return c.dataset.filter === filter && c.getAttribute('aria-pressed') === 'true'; })
        .map(function (c) { return c.dataset.value; });
    }

    function apply(pushUrl) {
      var roast = active('roast'), decaf = active('decaf'), taste = active('taste');
      var shown = 0;
      coffees.forEach(function (c) {
        var ok = matches(c, 'roast', roast) && matches(c, 'decaf', decaf) && matches(c, 'taste', taste);
        c.card.hidden = !ok;
        if (ok) shown++;
      });
      var by = sort ? sort.value : 'featured';
      coffees.slice().sort(function (a, b) {
        var d = 0;
        if (by === 'light') d = a.roast - b.roast;
        else if (by === 'dark') d = b.roast - a.roast;
        else if (by === 'price-asc') d = a.price - b.price;
        else if (by === 'price-desc') d = b.price - a.price;
        return d || a.index - b.index;
      }).forEach(function (c) { grid.appendChild(c.card); });

      var filtered = roast.length + decaf.length + taste.length > 0;
      if (count) count.textContent = filtered ? shown + ' of ' + coffees.length + ' coffees' : coffees.length + ' coffees';
      if (clearInBar) clearInBar.hidden = !filtered;
      var n = roast.length + decaf.length + taste.length;
      if (badge) { badge.hidden = !n; badge.textContent = n ? ' (' + n + ')' : ''; }
      if (empty) empty.hidden = shown !== 0;
      if (pushUrl) writeUrl({ roast: roast.concat(decaf), taste: taste, sort: by === 'featured' ? [] : [by] });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        apply(true);
      });
    });
    if (sort) sort.addEventListener('change', function () { apply(true); });
    Array.prototype.forEach.call(clears, function (b) {
      b.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        apply(true);
      });
    });

    // Filters can come in on the link, for example /collections/coffee-beans?roast=dark&taste=chocolate
    var params = new URLSearchParams(window.location.search);
    var want = (params.get('roast') || '').split(',').concat((params.get('taste') || '').split(','));
    chips.forEach(function (c) { if (want.indexOf(c.dataset.value) !== -1 && !c.hidden) c.setAttribute('aria-pressed', 'true'); });
    if (sort && params.get('sort') && sort.querySelector('option[value="' + params.get('sort') + '"]')) sort.value = params.get('sort');

    tools.hidden = false;
    apply(false);
  }

  function matches(c, filter, values) {
    if (!values.length) return true;
    if (filter === 'roast') return values.indexOf(ROAST_GROUP[c.roast]) !== -1;
    if (filter === 'decaf') return c.decaf;
    if (filter === 'taste') return values.some(function (v) { return c.tastes.indexOf(v) !== -1; });
    return true;
  }

  function writeUrl(state) {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    ['roast', 'taste', 'sort'].forEach(function (k) {
      if (state[k] && state[k].length) params.set(k, state[k].join(','));
      else params.delete(k);
    });
    var q = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
  }

  /* ---------- Coffee finder ---------- */
  function setupFinder(section, coffees) {
    var box = section.querySelector('[data-fs-finder]');
    if (!box) return;
    var intro = box.querySelector('[data-finder-intro]');
    var step = box.querySelector('[data-finder-step]');
    var progress = box.querySelector('[data-finder-progress]');
    var question = box.querySelector('[data-finder-question]');
    var answers = box.querySelector('[data-finder-answers]');
    var back = box.querySelector('[data-finder-back]');
    var result = box.querySelector('[data-finder-result]');
    var picks = [];

    function show(i) {
      // Decaf answers the rest: there's one decaf, so skip straight to it
      if (i > 0 && picks[0] && picks[0].decaf) i = QUESTIONS.length;
      if (i >= QUESTIONS.length) return finish();
      var q = QUESTIONS[i];
      intro.hidden = true;
      result.hidden = true;
      step.hidden = false;
      progress.textContent = 'Question ' + (i + 1) + ' of ' + QUESTIONS.length;
      question.textContent = q.text;
      answers.innerHTML = '';
      q.answers.forEach(function (a) {
        var b = el('button', 'fs-finder__answer', a.label);
        b.type = 'button';
        b.addEventListener('click', function () { picks[i] = a.value; show(i + 1); });
        answers.appendChild(b);
      });
      back.onclick = function () {
        if (i === 0) { reset(); return; }
        picks.length = i - 1;
        show(i - 1);
      };
      question.focus({ preventScroll: true });
    }

    function score(c, want) {
      var s = 0;
      if (want.decaf) s += c.decaf ? 20 : -20;
      else if (c.decaf) s -= 6;
      if (want.roast) s += 4 - 1.5 * Math.abs(c.roast - want.roast);
      if (want.taste && c.tastes.indexOf(want.taste) !== -1) s += 3;
      if (want.brew && c.brews.indexOf(want.brew) !== -1) s += 2;
      return s - c.index * 0.01;
    }

    function finish() {
      var want = {};
      picks.forEach(function (p) { if (p) Object.keys(p).forEach(function (k) { want[k] = p[k]; }); });
      var ranked = coffees.slice().sort(function (a, b) { return score(b, want) - score(a, want); });
      var top = ranked[0], next = ranked[1];
      step.hidden = true;
      result.innerHTML = '';

      var wrap = el('div', 'fs-finder__match');
      var media = el('a', 'fs-finder__photo');
      media.href = link(top, want);
      media.setAttribute('tabindex', '-1');
      media.setAttribute('aria-hidden', 'true');
      if (top.photo) {
        var img = el('img');
        img.src = top.photo;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      var copy = el('div', 'fs-finder__copy');
      copy.appendChild(el('p', 'fs-label', 'Your coffee'));
      copy.appendChild(el('h3', 'fs-d fs-d--md', top.name));
      if (top.roastLabel || top.origin) copy.appendChild(el('p', 'fs-pcard__roast', [top.roastLabel, top.origin].filter(Boolean).join(' · ')));
      if (top.notes) copy.appendChild(el('p', 'fs-pcard__notes', top.notes));
      if (top.line) copy.appendChild(el('p', 'fs-text fs-finder__line', top.line));
      var grindNote = want.brew === 'whole' ? 'Whole bean, ready for your grinder.' : (want.brew ? 'We grind it to order for ' + BREW_WORDS[want.brew] + '.' : '');
      if (grindNote) copy.appendChild(el('p', 'fs-finder__grind', grindNote));
      var row = el('div', 'fs-btn-row');
      var shop = el('a', 'fs-btn fs-btn--solid', 'Shop ' + top.name);
      shop.href = link(top, want);
      row.appendChild(shop);
      var again = el('button', 'fs-finder__link', 'Start over');
      again.type = 'button';
      again.addEventListener('click', function () { picks = []; show(0); });
      row.appendChild(again);
      copy.appendChild(row);
      if (next && (!want.decaf || next.decaf)) {
        var also = el('p', 'fs-finder__also');
        also.appendChild(document.createTextNode('Also worth a try: '));
        var a2 = el('a', '', next.name);
        a2.href = link(next, want);
        also.appendChild(a2);
        if (next.notes) also.appendChild(document.createTextNode(' (' + next.notes + ')'));
        copy.appendChild(also);
      }
      wrap.appendChild(media);
      wrap.appendChild(copy);
      result.appendChild(wrap);
      result.hidden = false;
      result.focus({ preventScroll: true });
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function link(c, want) {
      var g = want.brew ? c.grinds[BREW_GRIND[want.brew]] : null;
      return g ? c.url + (c.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + g : c.url;
    }

    function reset() {
      picks = [];
      step.hidden = true;
      result.hidden = true;
      intro.hidden = false;
    }

    box.querySelector('[data-finder-start]').addEventListener('click', function () { show(0); });
    box.hidden = false;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fs-shop]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor: rebuild when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-fs-shop]');
    if (s) init(s);
  });
})();
